import React from "react";
import styles from "../WalletConnector.module.css";
export default function WalletSelection({ onSelect }) {
  const wallets = [
    {
      id: "metamask",
      name: "Metamask",
      logo: "/img/metamask-69ce6b56bbc9953dfb4aecebdf88729b.png",
    },
    {
      id: "trust",
      name: "Trust Wallet",
      logo: "/img/trust-wallet-66f8777532931d9c09b633344981a6a9.png",
    },
    { id: "coinbase", name: "Coinbase", logo: "/img/coinbase.png" },
    { id: "phantom", name: "Phantom", logo: "/img/phantom.jpg" },
    { id: "solflare", name: "Solflare", logo: "/img/solflare.png" },
    { id: "xumm", name: "Xumm", logo: "/img/xumm.png" },
    { id: "cardano", name: "Cardano", logo: "/img/cardano.png" },
    { id: "daedalus", name: "Daedalus", logo: "/img/daedalus.png" },
    { id: "yoroi", name: "Yoroi", logo: "/img/yoroi.png" },
    { id: "ccvault", name: "CCVault", logo: "/img/ccvault.png" },
    { id: "gero", name: "Gero Wallet", logo: "/img/gero.jpg" },
    { id: "nami", name: "Nami Wallet", logo: "/img/nami.png" },
    { id: "sollet", name: "Sollet", logo: "/img/sollet.png" },
    { id: "solong", name: "Solong", logo: "/img/solong.jpg" },
    { id: "exodus", name: "Exodus", logo: "/img/exodus.png" },
    { id: "velas", name: "Velas", logo: "/img/velas.png" },
    {
      id: "crypto",
      name: "Crypto.com",
      logo: "/img/crypto-4cbeac57421fb3ca2573db2cf448169a.png",
    },
    {
      id: "blockchain",
      name: "Blockchain",
      logo: "/img/blockchain-logo.png",
    },
    {
      id: "bsc",
      name: "Binance Smart Chain",
      logo: "/img/bsc-logo.png",
    },
    {
      id: "safepal",
      name: "Safepal",
      logo: "/img/safepal-1022b40e2ea3a4a6bb19cf6ff28d8b92.png",
    },
    { id: "argent", name: "Argent", logo: "/img/image.jpg" },
    {
      id: "fortmatic",
      name: "Fortmatic",
      logo: "/img/formatic.png",
    },
    {
      id: "aktionariat",
      name: "Aktionariat",
      logo: "/img/aktionariat-c5784b26234a389632687a36d2fb3258.png",
    },
    {
      id: "keyring",
      name: "Keyring Pro",
      logo: "/img/keyringpro-830b2c0ee1db401dd64c2899eaf2adb3.png",
    },
    {
      id: "bitkeep",
      name: "BitKeep",
      logo: "/img/bitkeep-387b0ca7da4cf322f44c70c23064c529.png",
    },
    {
      id: "sparkpoint",
      name: "SparkPoint",
      logo: "/img/sparkpoint-5c0d3a4ab850a7ee2a3f03e215b68f2c.png",
    },
    {
      id: "ownbit",
      name: "OwnBit",
      logo: "/img/ownbit-0b6b21e40acf2fa0f85d2c5ce38c4c51.png",
    },
    {
      id: "infinity",
      name: "Infinity Wallet",
      logo: "/img/infinity-wallet-48e78bc97f96bad14ee6b781423a69ea.png",
    },
    {
      id: "walletio",
      name: "Wallet.io",
      logo: "/img/wallet.io-198f396de22fe25eb370f46544abe69d.png",
    },
    {
      id: "infinito",
      name: "Infinito Wallet",
      logo: "/img/infinito-wallet-68da061495160c96f4bcb5e70e612fdd.png",
    },
    { id: "torus", name: "Torus", logo: "/img/torus.jpeg" },
    { id: "nash", name: "Nash", logo: "/img/nash.jpeg" },
    {
      id: "bitpay",
      name: "BitPay",
      logo: "/img/bitpay-1573dd6c95eb38386f181048663590d0.jpg",
    },
    {
      id: "imtoken",
      name: "imToken",
      logo: "/img/imtoken-fd8c7c52dac6101568954e7448a49202.png",
    },
    {
      id: "other",
      name: "Other Wallet",
      logo: "/img/walleth-b60336f8dd9ea86285408cb4f96634d1.png",
    },
  ];

  return (
    <div className={styles.section}>
      <h2 className={styles.sectionTitle}>Connect to a wallet</h2>
      <div className={styles.walletGrid}>
        {wallets.map((wallet) => (
          <button
            key={wallet.id}
            className={styles.walletButton}
            onClick={() => onSelect(wallet)}
          >
            <div className={styles.walletInfo}>
              <div className={styles.statusDot}></div>
              <span className={styles.walletName}>{wallet.name}</span>
            </div>
            <img
              src={wallet.logo}
              alt={wallet.name}
              className={styles.walletIcon}
            />
          </button>
        ))}
      </div>
    </div>
  );
}
